import _http_v1 from "@packs/http_requests/_http_v1"
import store from "../store/store"
import measurement_helper from "./measurement_helper"
import _http_v2 from "@packs/http_requests/_http_v2"

const stationHelper = { 
    loading_stations:true,
    loading_measurements:true,
    getStationsMeasurements(station_ids, start_date, end_date){
        start_date = start_date || store.mainConfigStore.getPeriod().start()
        end_date = end_date || store.mainConfigStore.getPeriod().end()
        
        if(moment(end_date).format('YYYY-MM-DD') != moment().format('YYYY-MM-DD')){
            start_date = moment(end_date).format('YYYY-MM-DD') + ' 03:00'
            end_date = moment(end_date).add(1, 'day').format('YYYY-MM-DD') + ' 02:59'
            store.mainConfigStore.setRetro(true)
        } else {
            store.mainConfigStore.setRetro(false)
        }
        return _http_v2.request('measurements', 'GET', {
            station_prefix_ids: station_ids,
            start_date: start_date || store.mainConfigStore.getPeriod().start(),
            end_date: end_date || store.mainConfigStore.getPeriod().end(),
            group_type: 'minute'
        })
    },
    getStations(station_ids){
        return _http_v1.request('station_prefixes/simplify', 'GET', {
            station_prefix_ids: station_ids,
            additional_fields: ['transmission_gap']
        })
    },
    getEquations(station_ids){
        return _http_v1.request('equations', 'GET', {
            equationable_type: 'StationPrefix',
            equationable_ids: station_ids,
            additional_fields: ['transmission_gap'],
            equation_type_ids: [3,4]
        })
    },
    //a regra atual é: Se passou de 10 minutos, está atrasado mas ainda é tolerável e por isso é definido como 'Aguardando'
    // se passou de 20, está definitivamente atrasado
    getDelayStatus(transmission_gap,measurements){
        measurements = this.sortMeasurements(measurements)
        let now = new Date()
        if(measurements.length > 0){            
            let minutes = moment().diff(moment(measurements[0].date, 'YYYY/MM/DD HH:mm').subtract(3,'hours'), 'minutes')
            return (minutes - transmission_gap >= 10) ? 'ATRASADO' : (minutes - transmission_gap > 0) ? 'AGUARDANDO' : 'ATUALIZADO'
        } else {
            return 'ATRASADO'
        }
    },
    getReferenceValues(station_ids){
        return _http_v1.request('parameters', 'GET', {station_prefix_ids: station_ids,parameter_type_id: 2 /*reference_values*/})
    },
    sortMeasurements(measurements){
        return measurements.sort((x, y)=>new Date(y.date) - new Date(x.date))
    },
    referenceByValue(station_id, value){
        let station = store.stationStore.getStation(station_id)

        if(station && station.reference_values){
            let fields = ['extravasation','emergency','alert','attention']
            let reference_values = fields.map(x=> station.reference_values.values[x] ).sort((a,b)=>b-a)
            for(let i = 0; i < fields.length;i++){
                if(reference_values[i] && value >= reference_values[i]){
                    return fields[i]
                }
            }
            return null //status normal, nada a declarar
        }
        
    },
    calculateFlows(measurements, station_id){
        let equations = store.equationStore.equationsFromStation(station_id)
        measurements = measurement_helper.calculateFlows(measurements, equations)
        return measurements
    },
    colorByReference(reference){
        switch(reference){
            case 'attention':
                return {full:'#bda501', light:'#fff8ba'}
            case 'alert':
                return {full:'orange', light:'#ffdb91'}
            case 'emergency':
                return {full:'#cc00ff', light:'#f9e2ff'}
            case 'extravasation':
                return {full:'var(--danger)', light:'#ffe2e9'}
            default:
                return {full:'gray', light:'gray'}
        }
    }
}

export default stationHelper